import { Actions } from "./actions";

let defaultState = {
  refreshApiCallLocation: true,
  refreshApiCallPermission: true,
  refreshApiCallUser: true,
  refreshApiCallVendor: true,
  locationsList: [],
  permissionsList: [],
  userListData: [],
  vendorListData: [],
};

const mealAppReducer = (state = defaultState, action) => {
  switch (action.type) {
    case Actions.REFRESH_API_CALL_LOCATION:
      return {
        ...state,
        refreshApiCallLocation: action.data,
      };
    case Actions.REFRESH_API_CALL_PERMISSION:
      return {
        ...state,
        refreshApiCallPermission: action.data,
      };
    case Actions.REFRESH_API_CALL_USER:
      return {
        ...state,
        refreshApiCallUser: action.data,
      };
    case Actions.REFRESH_API_CALL_VENDOR:
      return {
        ...state,
        refreshApiCallVendor: action.data,
      };
    case Actions.LOCATIONS_LIST:
      return {
        ...state,
        locationsList: action.data,
      };
    case Actions.PERMISSION_LIST:
      return {
        ...state,
        permissionsList: action.data,
      };
    case Actions.USERLIST_DATA:
      return {
        ...state,
        userListData: action.data,
      };
    case Actions.VENDOR_LIST_DATA:
      return {
        ...state,
        vendorListData: action.data,
      };
    default:
      return { ...state };
  }
};

export default mealAppReducer;
